
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChosenFieldType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChosenFieldType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarkFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"generation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gearbox"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GearboxFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"engineType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EngineTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"driveType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DriveTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BodyTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"yearFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceTo"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":683}};
    doc.loc.source = {"body":"#import \"./markFieldType.gql\"\n#import \"./folderFieldType.gql\"\n#import \"./generationFieldType.gql\"\n#import \"./gearboxFieldType.gql\"\n#import \"./engineTypeFieldType.gql\"\n#import \"./driveTypeFieldType.gql\"\n#import \"./bodyTypeFieldType.gql\"\n#import \"./ownerFieldType.gql\"\nfragment ChosenFieldType on ChosenFieldType {\n  mark{\n    ... MarkFieldType\n  }\n  folder{\n    ... FolderFieldType\n  }\n  generation{\n    ... GenerationFieldType\n  }\n  gearbox{\n    ... GearboxFieldType\n  }\n  engineType{\n    ... EngineTypeFieldType\n  }\n  driveType{\n    ... DriveTypeFieldType\n  }\n  bodyType{\n    ... BodyTypeFieldType\n  }\n  owner{\n    ... OwnerFieldType\n  }\n  yearFrom\n  yearTo\n  priceFrom\n  priceTo\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./markFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./folderFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./generationFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./gearboxFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./engineTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./driveTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./bodyTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ownerFieldType.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ChosenFieldType"] = oneQuery(doc, "ChosenFieldType");
        
